<style scoped>

</style>
<template>
  <step lastRoute="adviserStep1" nextRoute="adviserStep3">

  </step>
</template>

<script>
  import step2 from '../../../../components/project/step2'
  export default {
    name: "step2",//利冲报告
    data:function(){
      return{

      }
    },
    methods:{

    },
    mounted:function(){

    },
    components:{
      step:step2,
    },
  }
</script>
